import PropTypes from 'prop-types';
import Anchor from 'sd-ui/dist/commonjs/components/Anchor/Anchor';
import CitedByListContainer from '../articleList/containers/citedByListContainer';
import PanelHeader from '../sidebar/panelHeader/panelHeader';

export default function CitedBy({ viewMoreUrl }) {
  return (
    <div className="sidebar-scroll-panel sidebar-panel-default-appearance">
      <PanelHeader title="Cited By" />
      <div className="sidebar-scroll-panel-body" id="citedby-panel">
        <CitedByListContainer />
        {viewMoreUrl && (
          <div className="branded u-padding-s-bottom text-s">
            <Anchor
              href={viewMoreUrl}
              id="more-citing-articles"
              target="_blank"
              rel="noopener noreferrer"
            >
              Find more citing articles
            </Anchor>
          </div>
        )}
      </div>
    </div>
  );
}

CitedBy.propTypes = {
  viewMoreUrl: PropTypes.string,
};

CitedBy.defaultProps = {
  viewMoreUrl: null,
};
